// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gNePc","containerWide":"styles_containerWide__HkfRT"};